<template>
    <div class="invalid-token-container">
        <p>{{$t('invalidToken')}}</p>
    </div>
</template>

<script>
export default {
  name: 'InvalidToken',
};
</script>

<style src="./InvalidToken.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/InvalidToken/InvalidToken.vue